import * as React from 'react';

import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';

import {
    PortCallProfile,
    PortCallProfileParams,
    TabVessel,
    TabPeople,
    TabLog
} from './model';
import { PortCallProfileView } from './view';
import { AppWrapper } from '../appwrapper/model';
import { AppWrapperView } from '../appwrapper/view';
import { NavbarTab } from '../navbar/view';

const
    TAB_PARAM_VESSEL = 'vessel',
    TAB_PARAM_PEOPLE = 'people',
    TAB_PARAM_LOG    = 'log';

export const PortCallProfileRoute = (model : (params : PortCallProfileParams) => PortCallProfile, appwrapper : AppWrapper, request : Location) : IRoute => {
    const m = model(inboundParams(request));
    return {
        view: 
            <AppWrapperView model={appwrapper} navbarTab={NavbarTab.Berths}>
                <PortCallProfileView model={m} />
            </AppWrapperView>,
        reflectState: () => new Location(request.name, outboundParams(m))
    };
};

function inboundParams(request : Location ) : PortCallProfileParams {
    return new PortCallProfileParams(
        +(request.params["id"] || 0),
        parseTab(request.params["tab"])
    );
}

function outboundParams(model : PortCallProfile) {
    const p = {} as LocationParams;

    p["id"] = "" + model.Id();

    const s = model.TabStrip.State();
    // Update query string on the LEADING edge of any flip animation.
    if (s.state === 'settled-on-back') {
        p["tab"] = serializeTab(s.tab);
    } else if (s.state === 'flipping-to-back') {
        p["tab"] = serializeTab(s.toTab);
    }

    return p;
}

function parseTab(tabParam : string | undefined) {
         if (tabParam === TAB_PARAM_VESSEL) return TabVessel;
    else if (tabParam === TAB_PARAM_PEOPLE) return TabPeople;
    else if (tabParam === TAB_PARAM_LOG   ) return TabLog;
    else return undefined;
}

function serializeTab(tab : object) {
         if (tab === TabVessel) return TAB_PARAM_VESSEL;
    else if (tab === TabPeople) return TAB_PARAM_PEOPLE;
    else if (tab === TabLog   ) return TAB_PARAM_LOG;
    else return undefined;
}



// WEBPACK FOOTER //
// ./apps/portcall/portcallprofile/route.tsx